<script lang="ts">
    import KpLoansGenericTable from './KpLoansGenericTable.svelte';
    import type {Loan} from 'typings/portaro.be.types';
    import {getDateFormatter, getLocalization} from 'core/svelte-context/context';
    import {pipe} from 'core/utils';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import LoanDocument from './LoanDocument.svelte';
    import {fade} from 'svelte/transition';
    import type {PageableList, PageableListState} from 'shared/utils/reactive-pageable-list';
    import type {EmptyObject} from 'typings/portaro.fe.types';
    import type {Observable} from 'rxjs';

    export let loanList: PageableList<Loan, string, EmptyObject>;

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();

    let loanListData: Observable<PageableListState<Loan, string, EmptyObject>>;
    $: loanListData = loanList.getState$();
</script>

<KpLoansGenericTable {loanList}>
    <tr slot="header">
        <th class="header-document-name">{localize(/* @kp-localization commons.nazevDokumentu */ 'commons.nazevDokumentu')}</th>
        <th class="header-lend-date">{localize(/* @kp-localization loan.DatumVypujceni */ 'loan.DatumVypujceni')}</th>
        <th class="header-return-date">{localize(/* @kp-localization loan.DatumVraceni */ 'loan.DatumVraceni')}</th>
        <th class="header-loan-type">{localize(/* @kp-localization loan.TypVypujcky */ 'loan.TypVypujcky')}</th>
    </tr>

    <svelte:fragment slot="body">
        {#each $loanListData.loadedItems ?? [] as loan(loan.id)}
            <tr class="loan-item" in:fade>
                <td class="data-document-name">
                    <LoanDocument loan="{loan}"/>
                </td>

                <td class="data-lend-date centered-loan-data">
                    {#if loan.lendDate}
                        {pipe(loan.lendDate, dateFormatter('d.M.yyyy'))}
                    {/if}
                </td>

                <td class="data-return-date centered-loan-data">
                    {#if loan.endDate}
                        {pipe(loan.endDate, dateFormatter('d.M.yyyy'))}
                    {/if}
                </td>

                <td class="data-loan-type centered-loan-data">
                    <IconedContent icon="info" orientation="vertical">
                        {loan.stateText}
                    </IconedContent>
                </td>
            </tr>
        {/each}
    </svelte:fragment>
</KpLoansGenericTable>